import "./consentcomponent.css";
import {
  Checkbox,
  Group,
  Paper,
  Stack,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";

interface ConsentComponentProps {
  grantedConsent: boolean;
  setGrantedConsent: (newValue: boolean) => void;
}

const ConsentComponent = ({
  grantedConsent,
  setGrantedConsent,
}: ConsentComponentProps) => {
  const theme = useMantineTheme();

  return (
    <Paper bg={theme.colors.red[1]} p="md" shadow="md">
      <Stack gap="xs">
        <Title order={5}>THIS INTERVIEW REQUIRES A TWO PARTY CONSENT.</Title>
        <Text>Please check "Granted consent" if the user has read:</Text>
        <Text fs="italic">
          "I’d like to record this interview and share the recording with a
          vendor, who will review the recording to provide me with feedback. Do
          I have your permission to do so?"
        </Text>
        <Text>and the interviewer agreed.</Text>
        <Group>
          <Title order={5}>Granted consent:</Title>
          <Checkbox
            checked={grantedConsent}
            onChange={() => setGrantedConsent(!grantedConsent)}
          />
        </Group>
      </Stack>
    </Paper>
  );
};

export default ConsentComponent;
